export const PortalSectionsEnum = {
  NavBar: {
    key: 0,
    name: "nav-bar",
    isMultiple: false,
  },
  Header: {
    key: 1,
    name: "header",
    isMultiple: false,
  },
  MediaAndTextSection: {
    key: 2,
    name: "media-text",
    isMultiple: true,
  },
  OpeningsSection: {
    key: 3,
    name: "openings",
    isMultiple: false,
  },
  GridSection: {
    key: 4,
    name: "grid",
    isMultiple: true,
  },
  GallerySection: {
    key: 5,
    name: "gallery",
    isMultiple: true,
  },
  TeamMembersSection: {
    key: 6,
    name: "team-members",
    isMultiple: true,
  },
  SliderSection: {
    key: 7,
    name: "slider",
    isMultiple: true,
  },
  LocationSection: {
    key: 8,
    name: "location",
    isMultiple: false,
  },
  QuoteSection: {
    key: 9,
    name: "quote",
    isMultiple: true,
  },
  PartnersSection: {
    key: 10,
    name: "partners",
    isMultiple: true,
  },
  SuccessStoriesSection: {
    key: 11,
    name: "success-stories",
    isMultiple: true,
  },
  CategoriesSection: {
    key: 12,
    name: "categories",
    isMultiple: false,
  },
  Footer: {
    key: 99,
    name: "footer",
    isMultiple: true,
  },
};
